<template>
	<div class="">
		<Header></Header>
		<div class="questionmore">
			<div class="wendalist">
			<ul>
				<li v-for="(item,index) in 4" :key='index' @click="openDetail()">
					<div class="wendatop">
						<p>报考教师需要普通话证书吗？普通话什么等级才能当老师？</p>
					</div>
					<div class="bottombox">
		
						<div class="boyya">
							<span><img width="16.5px" height="16.5px" src="../assets/home/bg4.png" /></span>
							<span>健康sad</span>
							<span>2012-12-12</span>
						</div>
						<div class="boyyb">
							<span><img width="18px" height="16px" src="../assets/home/num.png" /></span>
							<span>10</span>
						</div>
					</div>
				</li>
		
			</ul>
		</div>
		</div>
		<Fotter></Fotter>
		<div class="questionBtn">
			<p @click="myqueston">我要提问</p>
		</div>
		<!--提问弹层-->
		<van-dialog
		  v-model="show"
		  title="提问"
		  @confirm='sussessques'
		  @cancel='hidebox'
		  :close-on-click-overlay=true   
		  show-cancel-button
		>
		<van-field
			  v-model="message"
			  rows="1"
			  autosize
			  type="textarea"
			  placeholder="提问内容"
			/>
		  
		</van-dialog>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Quesrionmore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
                  show:false,
				  message:''
			}

		},
		methods: {
             //提问
			 myqueston(){
				 this.show= true;
			 },
			 //确定
			 sussessques(){
				 this.message='';
			 },
			 //q取消
			 hidebox(){
				this.message='';
			 },
			 openDetail(){
				 this.$router.push({path:'/Quesrionmore_detail'})
			 }
			 
		}
	}
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/Quesrionmore.vue